import React, { useState } from 'react';
import HealthBar from './HealthBar';

const CharacterProfile = ({ player, setPlayer, setGameLog, onUnequip }) => {
  const [isStatsCollapsed, setIsStatsCollapsed] = useState(false);
  const [isEquippedCollapsed, setIsEquippedCollapsed] = useState(false);
  const [isProgressCollapsed, setIsProgressCollapsed] = useState(false);

  // Function to round numbers to whole numbers
  const formatNumber = (num) => {
    return Math.round(num).toString();
  };

  // Calculate XP required for the next level (temporary formula)
  const calculateXpToNextLevel = (level) => {
    return 100 * Math.pow(level - 1, 2) + 100; // Example: Level 2 needs 100 XP, Level 3 needs 200 XP, etc.
  };

  // Get the XP required for the next level
  const xpToNextLevel = calculateXpToNextLevel(player.level + 1);

  return (
    <div className="character-profile">
      <div className="panel-header">
        <h3>{player.character_name || 'Adventurer'}</h3>
        <button
          className="collapse-toggle"
          onClick={() => setIsStatsCollapsed(!isStatsCollapsed)}
        >
          {isStatsCollapsed ? 'Expand' : 'Collapse'}
        </button>
      </div>

      {/* Player Vitals (HP, Mana, Stamina) */}
      {!isStatsCollapsed && (
        <div className="profile-section">
          <h4>Vitals</h4>
          <div className="stat-bar">
            <p>HP:</p>
            <HealthBar current={player.hp} max={player.maxHp} color="#df2320" />
          </div>
          <div className="stat-bar">
            <p>Mana:</p>
            <HealthBar current={player.mana} max={player.max_mana} color="#4040ff" />
          </div>
          <div className="stat-bar">
            <p>Stamina:</p>
            <HealthBar
              current={player.stamina}
              max={player.maxStamina || 100}
              color="#ffaa00"
            />
          </div>
        </div>
      )}

      {/* Stats Section */}
      {!isStatsCollapsed && (
        <div className="stats-group">
          <h4>Stats</h4>
          <p>Class: {player.class}</p>
          <p>Level: {player.level}</p>
          {/* Add XP Bar here */}
          <div className="stat-bar">
            <p>XP:</p>
            <HealthBar
              current={player.xp}
              max={xpToNextLevel}
              color="#8003fc" // Green color for XP bar
            />
          </div>
          <p>ATK: {formatNumber(player.atk)}</p>
          <p>DEF: {formatNumber(player.def)}</p>
          <p>Crit Chance: {formatNumber(player.crit_chance * 100)}%</p>
          <p>Crit Damage: {formatNumber(player.crit_damage * 100)}%</p>
          <p>Dodge Chance: {formatNumber(player.dodge_chance * 100)}%</p>
          <p>Status Resist: {formatNumber(player.status_resist * 100)}%</p>
          <p>Luck: {formatNumber(player.luck)}</p>
        </div>
      )}

      {/* Equipped Items Section */}
      <div className="panel-header">
        <h4>Equipped Items</h4>
        <button
          className="collapse-toggle"
          onClick={() => setIsEquippedCollapsed(!isEquippedCollapsed)}
        >
          {isEquippedCollapsed ? 'Expand' : 'Collapse'}
        </button>
      </div>
      {!isEquippedCollapsed && (
        <div className="equipped-items">
          {Object.entries(player.equipped).map(([slot, item]) => (
            <p key={slot}>
              {slot.charAt(0).toUpperCase() + slot.slice(1)}:{' '}
              {item ? item.name : 'None'}
              {item && (
                <button
                  className="unequip-button"
                  onClick={() => onUnequip(slot)}
                >
                  Unequip
                </button>
              )}
            </p>
          ))}
        </div>
      )}

      {/* Progress Section */}
      <div className="panel-header">
        <h4>Progress</h4>
        <button
          className="collapse-toggle"
          onClick={() => setIsProgressCollapsed(!isProgressCollapsed)}
        >
          {isProgressCollapsed ? 'Expand' : 'Collapse'}
        </button>
      </div>
      {!isProgressCollapsed && (
        <div className="progress-group">
          <p>Floors Cleared: {player.floorsCleared}</p>
          <p>Kills: {player.kills}</p>
          <p>Gold: {player.gold}</p>
          <p>Ectoplasm: {player.ectoplasm}</p>
          <p>XP: {player.xp}</p>
        </div>
      )}
    </div>
  );
};

export default CharacterProfile;